import React, { Fragment, useContext, useEffect, useState } from 'react';
import CustomBtn from '../../widgets/CustomBtn';

// Importing image assets
import editGreen from "../../../assets/images/edit.png";
import editImg from "../../../assets/images/whiteEdit.svg";
import printImg from "../../../assets/images/whitePrint.svg";
import deleteImg from "../../../assets/images/whiteDelete.svg";
import fixtureImg from "../../../assets/images/whiteFixture.svg";
import incidentImg from "../../../assets/images/incident.png";
import incidentGreen from "../../../assets/images/incident-green.png"
import incidentOrange from "../../../assets/images/incident-orange.png"
import incidentPink from "../../../assets/images/incident-pink.png"
import incidentRed from "../../../assets/images/incident-red.png"
import incidentYellow from "../../../assets/images/incident-yellow.png"

import {
  zoneList, printZone, publishZone, downloadZone, addZone, updateZone, deleteZone,
  getZoneFixture, getZoneFixtureIncident, getAllFixture, deleteZoneFixture, setClearZoneData
} from '../../_slice/zoneSlice';

import {
  addAssembly,
  deleteAssembly,
  updateAssembly
} from '../../_slice/assemblyPointSlice';

import CustomModal from '../../widgets/CustomModal';
import FixtureModal from '../../widgets/FixtureModal';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import AppContext from '../../context/AppContext';
import { useDispatch, useSelector } from 'react-redux';
import InfiniteScroll from "../../services/InfiniteScroll";

function Zones() {
  // State declarations
  const [assemblyModalShow, setAssemblyModalShow] = useState({ show: false, id: "" });
  const [modalShow, setModalShow] = useState({ show: false, id: '' });
  const [printModalShow, setPrintModalShow] = useState({ show: false, html: '', cclink: '', ccqrcodeurl: '' });
  const [iframeContent, setIframeContent] = useState('');
  const [deleteModal, setDeleteModal] = useState({ show: false, id: '', name: '', type: '' })
  const [downloadModal, setDownloadModal] = useState({ show: false, id: '', published: '' })
  const [fixtureModalShow, setFixtureModalShow] = useState({ show: false, zoneId: '', mode: '' });
  const [highlighted, setHighlighted] = useState([false, false, false]);
  const [showDetails, setShowDetails] = useState({});
  const [showParents, setShowParents] = useState({});
  const [checkedState, setCheckedState] = useState({});

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  // Other hook initializations
  const { setLoader } = useContext(AppContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const locationId = location?.state?.orglocation?.locationId || ''
  // const assemblyId = location?.state?.assembly?.assemblyId || '';

  // console.log('location?.state', location?.state);

  const onboardingData = useSelector(state => state?.onboarding);

  // React Hook Form setup
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    clearErrors,
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      name: '',
      notes: '',
      location_id: locationId || ''
    }
  });

  // React Hook Form setup for Assembly form
  const {
    register: registerAssembly,
    handleSubmit: handleSubmitAssembly,
    formState: { errors: errorsAssembly },
    setValue: setValueAssembly,
    clearErrors: clearErrorsAssembly,
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      name: '',  // Default empty value for 'name'
    }
  });

  // UseEffect to dynamically set 'zone_id'
  useEffect(() => {
    if (assemblyModalShow.show && assemblyModalShow.id) {
      setValueAssembly('zone_id', assemblyModalShow.id);  // Dynamically set zone_id when modal opens
    }
  }, [assemblyModalShow, setValueAssembly]);

  // Redux selector
  const { zoneData, status: zoneStatus, fixtureData, zoneFixtureData, zoneFixtureIncidentData } = useSelector(state => state.zone);
  // console.log('zoneData', zoneData);

  useEffect(() => {
    if (zoneStatus === 'idle' || locationId) {
      // dispatch(zoneList({ setLoader, locationId }));
      fetchMoreZones(0);
    }
  }, [locationId, navigate, dispatch, setLoader]);

  // Function to fetch more location
  const fetchMoreZones = (resetPage) => {
    const pageCount = resetPage > 0 ? resetPage : page;
    dispatch(zoneList({ locationId, pageCount, navigate, setLoader }))
      .then((response) => {
        // console.log('response', response);
        if (response?.payload?.data?.zones?.data?.length > 0) {
          setPage(response?.payload?.data?.zones?.current_page + 1);
          setHasMore(
            response?.payload?.data?.zones?.current_page <
            response?.payload?.data?.zones?.last_page
          );
        } else {
          setHasMore(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching more zones:", error);
      });
  };

  // Function to handle checkbox state changes
  const handleCheckboxChange = (event, id, name) => {

    const checked = event.target.checked;
    setCheckedState({ [id]: checked });
    setShowDetails({ [id]: checked });

    const {
      campus = { campId: '', campName: '' },
      orglocation = { locationId: '', locationName: '' },
      assembly = { assemblyId: '', assemblyName: '' },
      orgId = ''
    } = location?.state || {};

    const newState = {
      campus,
      orglocation,
      assembly,
      zone: {
        zoneId: checked ? id : '',
        zoneName: checked ? name : ''
      },
      orgId
    };
    if (checked) {
      getZoneFixtures(id)
    }

    navigate('.', { replace: true, state: newState });
  };

  // Function to create a new assembly
  const createAssembly = async (data) => {
    try {
      // Await the addAssembly dispatch
      await dispatch(addAssembly({ data, navigate, setLoader }));

      // Close the modal after assembly creation
      setAssemblyModalShow({ show: false, id: '' });

      // Await the setClearZoneData dispatch
      await dispatch(setClearZoneData());

      // Finally, fetch the updated zone list
      await dispatch(zoneList({ navigate, setLoader, locationId }));
    } catch (error) {
      console.error("Error creating assembly:", error);
    }
  };


  // Function to edit an existing assembly
  const editAssembly = data => {
    // dispatch(updateAssembly({ id: modalShow.id, data, navigate, setLoader, locationId }))
    // setModalShow({ show: false, id: '' })
  }

  // Zone Fixture Api Call On Click
  const zoneFixtureApi = (zoneId, ZoneAssembly) => {
    // console.log('zoneFixtureApi ZoneAssembly', ZoneAssembly);
    getZoneFixtures(zoneId, 'addAndEdit', ZoneAssembly)
  }

  // Function to toggle fixture modal visibility
  const openFixtureModal = (zoneId, mode, ZoneAssembly) => {
    // console.log('openFixtureModal  ZoneAssembly', ZoneAssembly);
    setFixtureModalShow({ show: true, zoneId: zoneId, mode: mode, ZoneAssembly: ZoneAssembly });
    if (fixtureData?.length === 0) getFixtures();
  };

  const closeFixtureModal = () => {
    setFixtureModalShow({ show: false, zoneId: '', mode: '', ZoneAssembly: '' });
  };

  // Function to toggle showParents
  const toggleParents = (id, fixtureId) => {

    setShowParents(prevState => {
      // Create a new object to hold the updated state
      const updatedState = {};

      // Iterate through all keys in prevState
      Object.keys(prevState).forEach(key => {
        // Toggle the specified id and set all other ids to false
        updatedState[key] = Number(key) === id ? !prevState[key] : false;
      });

      // Ensure the specified id is set to true if it was previously false or does not exist
      if (!prevState[id]) {
        updatedState[id] = true;
      }

      return updatedState;
    });

    getZoneFixtureIncidents(fixtureId);
  };

  // Function to highlight rows
  const handleHighlight = (index) => {
    const newHighlighted = [...highlighted];
    newHighlighted[index] = !newHighlighted[index];
    setHighlighted(newHighlighted);
  };

  // Function to create a new zone
  const createZone = data => {
    dispatch(addZone({ data, navigate, setLoader })).then(() => {
      setModalShow({ show: false, id: '' });
      dispatch(zoneList({ navigate, setLoader, locationId }));
    });
  };

  // Function to edit an existing zone
  const editZone = data => {
    dispatch(updateZone({ id: modalShow.id, data, navigate, setLoader, locationId }));
    setModalShow({ show: false, id: '' });
  };

  // Function to remove a zone
  const removeZone = id => {
    dispatch(deleteZone({ id, navigate, setLoader, locationId })).then(() => {
      dispatch(zoneList({ navigate, setLoader, locationId }));
    });
    setDeleteModal({ show: false })
  };

  // Function to get all fixtures
  const getFixtures = () => {
    dispatch(getAllFixture({ setLoader }));
  };

  // const publishZoneApi = async (id) => {
  //   const result = await dispatch(publishZone({ id, setLoader }));
  // };

  const publishZoneApi = async (id) => {
    const result = await dispatch(publishZone({ id, navigate, setLoader }));
    if (result.payload.url) {
      const link = document.createElement('a');
      link.href = result.payload.url;
      link.download = `zone_${result.payload.id}.zip`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const downloadScorm = async (id, type) => {
    const result = await dispatch(downloadZone({ id, type, navigate, setLoader }));
    if (result.payload.url) {
      const link = document.createElement('a');
      link.href = result.payload.url;
      link.download = `zone_${result.payload.id}.zip`; // Set a default filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    setDownloadModal({ show: false })
  };

  //  Function to print
  // const printZoneApi = async (id) => {
  //   const result = await dispatch(printZone({ id, setLoader }));
  //   if (result.payload && result.payload.html) {
  //     setPrintModalShow({ show: true, html: result.payload.html });
  //   }
  // };

  const printZoneApi = async (id, name, testKey) => {
    // console.log('Print id', id);
    // console.log('name', name);

    try {
      // Set the loader to true before starting the API call
      setLoader(true);

      const result = await dispatch(printZone({ id, testKey, navigate, setLoader }));

      if (!result?.payload?.html) {
        console.error("No HTML content received.");
        setLoader(false); // Close the loader if there's an error
        return;
      }

      if (!testKey) {
        const publish = 'publish';
        dispatch(zoneList({ navigate, setLoader, locationId, publish }));
      }

      // Set iframe content
      setIframeContent(result.payload.html);

      // Create and append iframe
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      document.body.appendChild(iframe);

      iframe.onload = () => {
        if (iframe.contentDocument) {
          const images = iframe.contentDocument.images;
          let imagesLoaded = 0;

          const checkImagesLoaded = () => {
            imagesLoaded++;
            if (imagesLoaded === images.length) {
              onImagesLoaded(result.payload, testKey, iframe, id, name);
            }
          };

          for (let img of images) {
            if (img.complete) {
              checkImagesLoaded();
            } else {
              img.onload = checkImagesLoaded;
              img.onerror = checkImagesLoaded;
            }
          }

          if (images.length === 0) {
            onImagesLoaded(result.payload, testKey, iframe, id, name);
          }
        } else {
          console.error("iframe contentDocument is null");
          setLoader(false); // Close the loader if there's an error
          document.body.removeChild(iframe);
        }
      };

      iframe.srcdoc = result.payload.html;

    } catch (error) {
      console.error("Error in printZoneApi:", error);
      setLoader(false); // Close the loader in case of error
    }
  };

  // Handle actions after all images are loaded
  const onImagesLoaded = (payload, testKey, iframe, id, name) => {

    if (testKey) {
      setPrintModalShow({
        show: true,
        html: payload.html,
        cclink: payload.cclink,
        ccqrcodeurl: payload.ccqrcodeurl,
        id: id,
        name: name
      });
    }

    document.body.removeChild(iframe);

    setLoader(true);
    // Ensure modal is shown before printing
    setTimeout(() => {
      printContent(payload.html, id, name);
    }, 4000);
  };

  const printContent = (htmlContent, zoneId, ZoneName) => {
    setLoader(false);
    const printWindow = window.open('', '_blank', 'width=800, height=600');

    if (printWindow) {
      const html = `
        <html>
          <head>
            <title>${ZoneName}</title>
            <style>
              @media print {
                @page {
                  margin: 0; /* Attempt to remove browser-added headers and footers */
                }
                .pagebreak { 
                  page-break-before: always; 
                }
              }
            </style>
          </head>
          <body>${htmlContent}</body>
        </html>
      `;

      const doc = printWindow.document;
      doc.open();
      doc.write(html);
      doc.close();

      printWindow.onload = () => {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
        setLoader(false); // Close the loader after printing
      };
    } else {
      console.error('Failed to open print window.');
      setLoader(false); // Close the loader if the print window fails to open
    }
  };

  // const printContent = (htmlContent) => {
  //     const printWindow = window.open('', '_blank', 'width=800,height=600');
  //     printWindow.document.open();
  //     printWindow.document.write(`
  //         <html>
  //             <head>
  //                 <title>Print</title>
  //                 <style>
  //                     @media print {
  //                         .pagebreak { page-break-before: always; }
  //                     }
  //                 </style>
  //             </head>
  //             <body>${htmlContent}</body>
  //         </html>
  //     `);
  //     printWindow.document.close();

  //     const images = printWindow.document.images;
  //     let imagesLoaded = 0;

  //     const checkImagesLoaded = () => {
  //         imagesLoaded++;
  //         if (imagesLoaded === images.length) {
  //             requestAnimationFrame(() => {
  //                 printWindow.focus();
  //                 printWindow.print();
  //                 printWindow.close();
  //             });
  //         }
  //     };

  //     for (let img of images) {
  //         if (img.complete) {
  //             checkImagesLoaded();
  //         } else {
  //             img.onload = checkImagesLoaded;
  //             img.onerror = checkImagesLoaded;
  //         }
  //     }

  //     if (images.length === 0) {
  //         requestAnimationFrame(() => {
  //             printWindow.focus();
  //             printWindow.print();
  //             printWindow.close();
  //         });
  //     }
  // };


  // Function to get fixtures for a particular zone
  const getZoneFixtures = (id, type, ZoneAssembly) => {
    // console.log('getZoneFixtures ZoneAssembly', ZoneAssembly);

    // Value True
    setCheckedState({ [id]: true });
    setShowDetails({ [id]: true });

    dispatch(getZoneFixture({ id, navigate, setLoader })).then((item) => {
      if (type === 'addAndEdit') {
        openFixtureModal(id, `${item?.payload?.zoneFixtures?.length > 0 ? 'edit' : 'add'}`, ZoneAssembly);
      }
    });
  };

  // Function to get fixtures for a particular zone
  const getZoneFixtureIncidents = (id) => {
    dispatch(getZoneFixtureIncident({ navigate, id, setLoader }));
  };

  // Function to remove a fixture
  const removeZoneFixture = id => {
    const selectedZoneId = location?.state?.zone?.zoneId || '';

    dispatch(deleteZoneFixture({ id, navigate, setLoader, selectedZoneId })).then(() => {
      // dispatch(zoneList({ setLoader, locationId }));
    });
    setDeleteModal({ show: false })
  };

  // Effect to reset form values and clear errors when the modal is closed
  useEffect(() => {
    if (!modalShow.show) {
      setValue('name', '');
      setValue('notes', '');
      clearErrors();
    }
  }, [modalShow.show, setValue, clearErrors]);

  // const isDisabledAddBtn = zoneData?.data?.length < 1;

  // console.log('isDisabledAddBtn', isDisabledAddBtn);
  // console.log('zoneData length', zoneData?.data?.length);

  return (
    <>
      <div className='org'>
        <div className='org_header d-flex align-items-center justify-content-between'>
          <h1 className='org_header_heading'>Zones</h1>
          {/* {zoneData?.data?.length < 1 && (
            <button type='button' className='submit_btn' onClick={() => setModalShow({ show: true })}>+ Add Zones</button>
          )} */}
          <button
            type='button'
            className='submit_btn'
            // className={`submit_btn ${isDisabledAddBtn ? '' : 'disabled pointer-none'}`}
            onClick={() => setModalShow({ show: true })}
          >
            + Add Zones
          </button>
        </div>
        <InfiniteScroll
          fetchMoreData={() => fetchMoreZones(0)}
          hasMore={hasMore}
          isLoading={zoneStatus === 'loading'}
          threshold={200}
        >
          <div className='org_table table-border-0 table-responsive'>
            <table className="table position-relative">
              <thead>
                <tr>
                  <td className='org_table_column w-5 zone_table_heading'> </td>
                  <td className='org_table_column w-20 zone_table_heading'>Zone Name</td>
                  <td className='org_table_column w-20 zone_table_heading'>Notes</td>
                  <td className='org_table_column w-20 zone_table_heading'>Assembly Points</td>
                  <td className='org_table_column w-35 text-center zone_table_heading'>Action</td>
                </tr>
              </thead>
              <tbody>
                {zoneData?.data?.map(item => (
                  <Fragment key={item.id}>
                    <tr key={item.id}>
                      <td className='org_table_row w-5 zone_body_text'>
                        <label className='check_box ml-2' htmlFor={`checkbox-${item.id}`}>
                          <input
                            type='checkbox'
                            id={`checkbox-${item.id}`}
                            checked={checkedState[item.id] || false}
                            onChange={(e) => handleCheckboxChange(e, item.id, item.name)}
                          />
                          <span className='checkbox_check'></span>
                        </label>
                      </td>
                      <td className='org_table_row w-20 zone_body_text'>{item?.name}</td>
                      <td className='org_table_row w-20 zone_body_text'>{item?.notes}</td>
                      <td className='org_table_row w-20 zone_body_text'>
                        {/* {location?.state?.assembly?.assemblyName} */}
                        {item?.assembly_point?.name ? (
                          <>
                            {item?.assembly_point?.name}
                            {/* <img src={editGreen} alt="" /> */}
                          </>
                        ) : (
                          <button type='button' className='action_new_btn bgGreen mr-2' title="Add Assembly"
                            onClick={() => setAssemblyModalShow({ show: true, id: item.id })}>
                            + Add Assembly
                          </button>
                        )}
                      </td>
                      <td className='org_table_row w-35 zone_body_text'>
                        <div className='d-flex align-items-center justify-content-center'>
                          <button
                            type='button'
                            className='action_new_btn bgGreen mr-2'
                            title="Delete"
                            // onClick={() => removeZone(item.id)}
                            onClick={() => setDeleteModal({ show: true, id: item.id, name: item.name, type: 'zone' })}
                          >
                            <img src={deleteImg} alt='' className='' />
                          </button>

                          <button type='button' className='action_new_btn bgGreen mr-2' title="Edit" onClick={() => {
                            setModalShow({ show: true, id: item.id })
                            setValue('name', item.name)
                            setValue('notes', item.notes)
                          }}>
                            <img src={editImg} alt='' className='' />
                          </button>

                          {/* <button type='button' className='action_btns' onClick={() => openFixtureModal(item.id, `${zoneFixtureData?.length > 0 ? 'edit' : 'add'}`)}> */}
                          <button type='button' className='action_new_btn bgGreen mr-2' title="Fixture" onClick={() => zoneFixtureApi(item.id, item?.assembly_point?.name)}>
                            <img src={fixtureImg} alt='' className='mr-1' /> Fixtures
                          </button>


                          {(item.zone_fixtures_count > 0 || (zoneFixtureData?.length > 0 && (item.id === zoneFixtureData[0].zone_id))) && (
                            <button type='button' className='action_new_btn bgBlack mr-2' title="Publish" onClick={() => printZoneApi(item.id, item.name, true)}>
                              {/* <img src={printImg} alt='' className='' /> */}
                              Publish
                            </button>
                          )}

                          {/* {item?.course_recording_count > 0 && (
                            <button
                              type='button'
                              className='action_new_btn bgBlack mr-2'
                              title="Publish"
                              onClick={() => printZoneApi(item.id, false)}
                            >
                              Publish
                            </button>
                          )} */}

                          {/* {item?.course_recording_count > 0 && (
                            <button
                              type='button'
                              className='action_new_btn bgBlack mr-2'
                              title="Download Scorm"
                              onClick={() => setDownloadModal({ show: true, id: item.id, published: item.published })}
                            // onClick={() => downloadScorm(item.id)}
                            >
                              Download Scorm
                            </button>
                          )} */}

                          {/* New 10 Sep */}
                          {item?.course_recording_count > 0 && (
                            <button
                              type='button'
                              className='action_new_btn bgBlack mr-2'
                              title="Download Scorm"
                              onClick={() => downloadScorm(item.id, true)}
                            >
                              Download Scorm
                            </button>
                          )}

                        </div>
                      </td>
                    </tr>

                    {showDetails[item.id] && (

                      <tr key={`details-${item.id}`}>
                        <td colSpan={5} className='pt-0 pl-0 pb-0'>
                          <div className={`table-responsive fixturePaddingCustom ${zoneFixtureData?.length > 5 ? "fixtureTableInn" : 'heightauto'}`}>
                            <table className='w-100'>
                              <thead>
                                <tr>
                                  <td className='org_table_column w-5 zone_table_heading'> </td>
                                  <td className='org_table_column w-20 zone_table_heading'>Fixture Name</td>
                                  <td className='org_table_column w-30 zone_table_heading'>Fixture Reference</td>
                                  <td className='org_table_column w-30 zone_table_heading'>Fixture Reference No.</td>
                                  <td className='org_table_column w-20 text-center zone_table_heading'>Action</td>
                                </tr>
                              </thead>
                              <tbody>
                                {zoneFixtureData?.filter(fixture => fixture.zone_id === item.id).map(data =>
                                  <Fragment key={data.id}>
                                    <tr key={data.id}>
                                      {/* Check Assembly Point True August */}
                                      {data?.fixture?.extras?.assembly_point ? null : (
                                        <>
                                          <td className='org_table_row_nested w-5 pt-0 zone_body_text'>
                                            <label className="check_box ml-2 cursor-default" htmlFor={`checkboxIncident-${data?.id}`}>
                                              <input
                                                type="checkbox"
                                                id={`checkboxIncident-${data?.id}`}
                                                checked={showParents[data.id] || false}
                                                onChange={(e) => toggleParents(data.id, data.fixture_id)}
                                                disabled={!data?.fixture?.extras?.incidents_enabled}
                                              />
                                              <span className="checkbox_check"></span>
                                            </label>
                                          </td>
                                          <td className='org_table_row_nested w-10 zone_body_text'>{data?.fixture?.name}</td>
                                          <td className='org_table_row_nested w-30 zone_body_text'>{data?.reference_name}</td>
                                          <td className='org_table_row_nested w-30 zone_body_text'>{data?.serial_number}</td>
                                          <td className='org_table_row_nested w-20 zone_body_text'>
                                            <div className='d-flex align-items-center justify-content-center'>
                                              {/* <button type='button' className='action_btns mr-3' onClick={() => setDeleteModal({ show: true, id: data.id, name: data?.fixture?.name, type: 'fixture' })}>
                                                <img src={deleteImg} alt='' className='mr-1' />
                                              </button> */}

                                              <button type='button' className='action_btns mr-3' onClick={() => openFixtureModal(item?.id, 'edit', item?.assembly_point?.name)}>
                                                <img src={editImg} alt='' className='mr-1' />
                                              </button>

                                              {/* {data?.fixture?.extras?.incidents_enabled ? (
                                                <button type='button' className='action_btns' onClick={(e) => toggleParents(data.id, data.fixture_id)}>
                                                  <img src={incidentImg} alt='' className='mr-1' />
                                                </button>
                                              ) : ""} */}

                                              <button
                                                type='button'
                                                onClick={(e) => toggleParents(data.id, data.fixture_id)}
                                                className={`action_btns ${!data?.fixture?.extras?.incidents_enabled ? 'pointer-none disabled' : ''}`}
                                              >
                                                <img src={incidentImg} alt='' className='mr-1' />
                                              </button>

                                            </div>
                                          </td>
                                        </>
                                      )}
                                    </tr>

                                    {showParents[data.id] &&
                                      <>
                                        {zoneFixtureIncidentData?.map(value => (
                                          <tr key={value.id}>
                                            <td colSpan={5} className='pt-0 pl-0 pb-0 zone_body_text'>

                                              <div className='showparentsection'>
                                                <div className='position-relative showparentsection_inner_part'>
                                                  <div className='incidents'>
                                                    Incidents
                                                  </div>
                                                </div>
                                                <div className='incidents_imgs_text'>
                                                  <div className='incidents_imgs'>
                                                    {value?.incidents?.map((incident) => (
                                                      <div className='incidentCard mb-4 mr-3' key={incident?.id}>
                                                        <div className="incidentCard-header">
                                                          {value.color_type === 'green' && <img src={incidentGreen} alt='' className='loci-icon' />}
                                                          {value.color_type === 'yellow' && <img src={incidentYellow} alt='' className='loci-icon' />}
                                                          {value.color_type === 'pink' && <img src={incidentPink} alt='' className='loci-icon' />}
                                                          {value.color_type === 'red' && <img src={incidentRed} alt='' className='loci-icon' />}
                                                          {value.color_type === 'orange' && <img src={incidentOrange} alt='' className='loci-icon' />}
                                                          <div className='incidentCard-header-inner'>
                                                            <h3 className='incident-heading'>{incident.name}</h3>
                                                            <p className='incident-subheading'>{value.name}</p>
                                                          </div>
                                                        </div>
                                                        <div className='incidentCard-body'>
                                                          <img src={incident?.image ? process.env.REACT_APP_MEDIA_URL + incident?.image : ""} alt='' className='incidentCard-body-img' />
                                                        </div>
                                                      </div>
                                                    ))}
                                                  </div>
                                                  <p className='incidents_para'>Be sure to select incidents that could happen in ZONE 2B, if you’re not familiar with the hazards in this area, pause now and physically inspect the zone, make some notes about common hazards and return to complete the incident selection for your course.</p>
                                                </div>
                                              </div>

                                            </td>
                                          </tr>
                                        ))}
                                      </>
                                    }
                                  </Fragment>

                                )}

                              </tbody>
                            </table>
                          </div>

                        </td>
                      </tr>
                    )}
                  </Fragment>
                ))}

              </tbody>
            </table>
          </div>
        </InfiniteScroll>
      </div>


      <CustomModal
        show={modalShow.show}
        onHide={() => setModalShow({ show: false })}
        heading={modalShow.id ? 'Edit Zone' : 'Add Zone'}
        size="md"
        body={
          <form onSubmit={
            modalShow.id
              ? handleSubmit(editZone)
              : handleSubmit(createZone)
          }
          >
            <div className='row'>
              <div className="col-lg-12">
                <div className="form-group mt-4">
                  <label htmlFor='zone-name' className='innerlable'>Zone Name</label>
                  <input type="text" className="form-control" placeholder="type here" maxLength={12} id='zone-name'  {...register('name', { required: 'Zone name required' })} />
                  {errors.name && (
                    <p className='text-danger'>{errors.name.message}</p>
                  )}
                </div>
              </div>
              <div className="col-lg-12">
                <div className="form-group mt-4">
                  <label htmlFor="zone-notes" className='innerlable'>Notes (Optional)</label>
                  <textarea className="form-control" id="zone-notes" rows="5" maxLength={250} placeholder='Max. 250 characters' {...register('notes', {})}></textarea>
                  {/* <textarea className="form-control" id="zone-notes" rows="5" maxLength={250} placeholder='Max. 250 characters' {...register('notes', { required: 'Notes required' })}></textarea> */}
                  {errors.notes && (
                    <p className='text-danger'>{errors.notes.message}</p>
                  )}
                </div>
              </div>
            </div>
            <CustomBtn
              buttonText="Save"
              className="mt-5"
              type="submit"
              id="campusName"
            />
          </form>
        }
      />

      {/* Assembly Add */}
      <CustomModal
        show={assemblyModalShow.show}
        onHide={() => setAssemblyModalShow({ show: false })}
        heading={!assemblyModalShow.id ? 'Edit Assembly Point' : 'Add Assembly Point'}
        size="md"
        body={
          <form onSubmit={
            !assemblyModalShow.id
              ? handleSubmitAssembly(editAssembly)
              : handleSubmitAssembly(createAssembly)
          }
          >
            <div className='row'>
              <div className="col-lg-12">
                <div className="form-group">
                  <label className='innerlable'>Assembly Points Name</label>
                  <input type="text" className="form-control" placeholder="type here" {...registerAssembly('name', { required: 'Assembly Points name required' })} />
                  {errorsAssembly.name && (
                    <p className='text-danger'>{errorsAssembly.name.message}</p>
                  )}
                </div>

                {/* Hidden field to store zone_id */}
                <input type="hidden" {...registerAssembly('zone_id')} />

                <CustomBtn
                  buttonText="Save"
                  className="mt-5"
                  type="submit"
                  id="assemblyName" />
              </div>
            </div>
          </form>
        }
      />

      <FixtureModal
        show={fixtureModalShow.show}
        onHide={closeFixtureModal}
        fixtureData={fixtureData}
        zoneId={fixtureModalShow.zoneId}
        mode={fixtureModalShow.mode}
        ZoneAssembly={fixtureModalShow.ZoneAssembly}
      />

      {/* delete modal */}
      <CustomModal
        show={deleteModal.show}
        onHide={() => setDeleteModal({ show: false })}
        // heading="Delete Campus"
        size="md"
        body={
          <div className='deleteModal'>
            <p className='text-center mb-5'>Are you sure, you want to delete this {deleteModal.name}?</p>
            <div className='d-flex justify-content-between align-items-center custom_bottom_padding'>
              <button type='button' className='submit_btn' onClick={() => deleteModal.type === 'zone' ? removeZone(deleteModal.id) : removeZoneFixture(deleteModal.id)}>Yes</button>
              <button type='button' className='cancleBtn' onClick={() => setDeleteModal({ show: false })}>No</button>
            </div>
          </div>
        }
      />

      {/* Print Popup */}
      <CustomModal
        show={printModalShow.show}
        onHide={() => setPrintModalShow({ show: false, html: '', cclink: '', ccqrcodeurl: '', id: '', name: '' })}
        // heading="Print"
        heading={
          <div className="d-flex justify-content-between align-items-center">
            <button type='button' className="qr-link mt-4" title="Print" onClick={() => printZoneApi(printModalShow.id, printModalShow.name, true)}>
              Print
            </button>
            <p className='textStyle'>If you have not already, 'Print' the course & start fresh with scanning new Course Creation QR below.</p>
          </div>
        }
        size="xl"
        className="custom-modal"
        body={
          <>
            <div className='text-center'>
              <h2 className='mb-4'><b>Scan to complete Course Creation</b></h2>
              <p className='mb-4'>
                The remainder of the course installation will occur on a mobile device.
                Please scan this code to be taken directly to the course creator and follow the instructions.
              </p>
              <div>
                <img src={printModalShow?.ccqrcodeurl} alt="" className='' />
              </div>
              {/* <a href={printModalShow.cclink} target="_blank" rel="noopener noreferrer" className="qr-link mb-4">
                Share Course Creator Link
              </a> */}
            </div>
            {/* <iframe
              srcDoc={printModalShow.html}
              style={{ width: '100%', height: '100%', border: 'none' }}
              title="Print Content"
            ></iframe> */}
          </>
        }
      />

      {/* download modal */}
      <CustomModal
        show={downloadModal.show}
        onHide={() => setDownloadModal({ show: false })}
        heading="Download Scorm"
        size="md"
        body={
          <div className='deleteModal'>
            {/* <p className='text-center mb-5'><b>Download</b></p> */}
            <div className='d-flex justify-content-center align-items-center custom_bottom_padding'>
              <button
                type='button'
                className='cancleBtn mr-2'
                onClick={() => downloadScorm(downloadModal.id, true)}
              >
                Test Scorm
              </button>
              {downloadModal.published === 1 && (
                <button
                  type='button'
                  className='cancleBtn'
                  onClick={() => downloadScorm(downloadModal.id, false)}
                >
                  Live Scorm
                </button>
              )}
            </div>
          </div>
        }
      />

    </>

  )
}

export default Zones